import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';

const LogoXxsmall = (): React.JSX.Element => {
	return <AtlassianIcon size="xxsmall" appearance="brand" />;
};

export default LogoXxsmall;
